<template>
  <el-tabs v-model="tab">
    <el-tab-pane label="All Users" name="users">
      <users
        :app-name="app.name"
        :app-code="app.code"
        :imported.sync="imported"
      />
    </el-tab-pane>
    <el-tab-pane label="Importations" name="batches"
      ><users-importation :app-code="app.code" :imported="imported" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import Users from "@/components/Products/AuthX/Applications/Users/Users";
import UsersImportation from "@/components/Products/AuthX/Applications/Users/UsersImportations";

import apiConstants from "@/apiConstants";

import * as mutations from "@/store/mutation-types";

export default {
  name: "AuthXUsers",
  components: {
    UsersImportation,
    Users
  },
  data() {
    return {
      tab: "users",
      imported: false
    };
  },
  computed: {
    app() {
      return this.$store.getters.authx_app;
    },

    appId() {
      return this.$route.params.id;
    }
  },

  created() {
    if (!this.app.name) {
      this.getApp();
    }
  },
  methods: {
    getApp() {
      const apiUrl = `apps/${this.appId}`;
      this.$http
        .post(
          apiUrl,
          {
            method: "GET"
          },
          {
            headers: {
              "data-baseurl-namespace": apiConstants.URLS.AUTHX
            }
          }
        )
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          } else {
            this.setAuthxApp(resData);
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
        });
    },
    setAuthxApp(data) {
      this.$store.commit(mutations.SET_AUTHX_APP, data);
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;

  p {
    width: 100px;
  }
}
</style>
